module.exports = __webpack_public_path__ + "img/apply-prof.32c5cc78.svg";